// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2CK5X","content":"LayoutSettings_content__1SY8K"};